export { default, getServerSideProps } from '@views/catalog/collections/[code]';
